exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".changeAvatar{display:inline-block;width:200px}.changeAvatar canvas{width:200px;height:200px}", "", {"version":3,"sources":["C:/Users/fpluq/Projects/groopus-vue/src/components/Profile/ChangeAvatar.vue"],"names":[],"mappings":"AACA,cACE,qBAAsB,AACtB,WAAa,CACd,AACD,qBACI,YAAa,AACb,YAAc,CACjB","file":"ChangeAvatar.vue","sourcesContent":["\n.changeAvatar {\n  display: inline-block;\n  width: 200px;\n}\n.changeAvatar canvas {\n    width: 200px;\n    height: 200px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f1c1eb28","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"indentedSyntax":true,"sourceMap":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Profile/ChangeAvatar.vue
// module id = 942
// module chunks = 2 4 5